import Workshop from './index';

export default [
  {
    path: '/home',
    component: Workshop,
    meta: {
      hiddenBreadCrumb: true,
      menuRender: false,
      title: 'home',
      nodeId: 0,
    },
  },
];
